import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export class BaseAPIService {

    protected constructor(
        protected http: HttpClient,
    ) {
    }

    protected GET<T>(url: string, context?: any, opts: any = {}): Observable<T | any> {
        if (context) {
            return this.http.get<T>(this.inject(url, context), opts);
        } else {
            return this.http.get<T>(url, opts);
        }
    }

    protected POST<T>(url: string, context?: any, body?: any, opts: any = {}): Observable<T | any> {
        if (context) {
            return this.http.post<T>(this.inject(url, context), body || {}, opts);
        } else {
            return this.http.post<T>(url, body || {}, opts);
        }
    }

    protected PATCH<T>(url: string, context?: any, body?: any, opts: any = {}): Observable<T | any> {
        if (context) {
            return this.http.patch<T>(this.inject(url, context), body || {}, opts);
        } else {
            return this.http.patch<T>(url, body || {}, opts);
        }
    }

    protected PUT<T>(url: string, context?: any, body?: any, opts: any = {}): Observable<T | any> {
        if (context) {
            return this.http.put<T>(this.inject(url, context), body || {}, opts);
        } else {
            return this.http.put<T>(url, body || {}, opts);
        }
    }

    protected DELETE<T>(url: string, context?: any, opts: any = {}): Observable<T | any> {
        if (context) {
            return this.http.delete<T>(this.inject(url, context), opts);
        } else {
            return this.http.delete<T>(url, opts);
        }
    }

    protected inject(restApi: string, context?: any): string {
        let properties = restApi.match(/(:\w+)/g);

        properties.forEach((property: string) => {
            let contextVar = property.substring(1);
            let contextValue = context[contextVar];

            if (contextValue !== undefined) {
                restApi = restApi.replace(property, contextValue);
            } else {
                throw new Error('inject: context.' + contextVar + ' expected but undefined');
            }
        });

        return restApi;
    }

}
